/**
 * @fileoverview Sponsored-listing disclosure copy (WEB-535).
 *
 * Single source of truth for the legal-owned disclosure sentence rendered
 * inside `<SponsoredTooltip>` on every sponsored surface (Discover list rows,
 * HappeningCard rails). The wording is the operator-approved DES-53 copy —
 * do not reword without a fresh operator/legal sign-off.
 *
 * "learn more" links to the sponsored-content policy page on the apex host
 * (`loci.city/legal/sponsored-content`). Sponsored cards render on the app
 * surface (`app.loci.city`), where a relative `/legal/...` href would fall
 * outside the surface registry — so the link is built with `apexUrl()`.
 *
 * There is deliberately NO "report" link — no report flow exists; the copy
 * ends at "learn more".
 */

import * as React from 'react';

import { apexUrl } from '@/lib/cross-host-urls';

/** Apex-relative path of the sponsored-content policy page. */
export const SPONSORED_CONTENT_POLICY_PATH = '/legal/sponsored-content';

/** Approved disclosure sentence (DES-53), minus the trailing link label. */
export const SPONSORED_DISCLOSURE_TEXT =
  "The event's sponsor paid to feature this event. LOCI still applies editorial standards.";

/** Label of the trailing policy link. */
export const SPONSORED_DISCLOSURE_LINK_LABEL = 'learn more';

/**
 * The disclosure body rendered into `<SponsoredTooltip>`'s legal-owned
 * `children` slot: approved sentence + "learn more" policy link.
 */
export function SponsoredDisclosureCopy(): React.ReactElement {
  return (
    <>
      {SPONSORED_DISCLOSURE_TEXT}{' '}
      <a
        href={apexUrl(SPONSORED_CONTENT_POLICY_PATH)}
        style={{ color: 'inherit', textDecoration: 'underline', fontWeight: 600 }}
        data-testid="sponsored-disclosure-learn-more"
      >
        {SPONSORED_DISCLOSURE_LINK_LABEL}
      </a>
    </>
  );
}
